export default __webpack_public_path__ + "static/Torneira-ac9ba68882176e94208e416fae3233b8.svg";